import variables from './variables'
import blobImgMiddleSchool from 'experienceComponents/LandingBanner/assets/landingBannerBlobs.svg'
import subBlobImgMiddleSchool from 'experienceComponents/SubLandingBanner/assets/subLandingBannerBlobs.svg'
import contentBlobImgMiddleSchool from 'experienceComponents/ContentTypeDescription/assets/backgroundBlobs.svg'
import backgroundImage from 'experienceComponents/UnitOverview/assets/img_unit_overview_blobs.svg'

export default {
  meta: { themeName: 'middleschool' },

  globalNav: {
    background: variables.colors.msdigital2,
    iconHoverBackground: variables.colors.opacity_40,
  },

  skipToMain: {
    background: variables.colors.opacity_40,
  },

  colors: {
    textBase: variables.colors.darkGray,
    themeAccent: variables.colors.blue,
    themeHighlight: variables.colors.middleSchoolMediumBlue,
    themePrimary: variables.colors.msdigital2,
    themeSecondary: variables.colors.msdigital2,
    themeDark: variables.colors.middleSchoolDarkBlue,
    classCardHover: variables.colors.msdigital7,
    tierLabel: variables.colors.aliceBlue,
    accordion: {
      headerTextColor: variables?.colors?.darkBlue,
      icon: variables?.colors?.blueGray,
      iconHoverColor: variables?.colors?.darkBlue,
      panelColor: variables?.colors?.paleGray,
    },
    backgrounds: {
      primary: variables.colors.blue,
    },
    borders: {
      primary: variables?.colors?.transparent,
      complete: variables?.colors?.transparent,
    },
    buttons: {
      primary: {
        bgActive: variables?.colors?.blue,
        bgHover: variables?.colors?.secondStepBlue,
        bgComplete: variables?.colors?.backgroundNeutralGray,
        labelHover: variables.colors.white,
        titleActive: variables.colors.white,
      },
      secondary: {
        labelActive: variables?.colors?.blue,
        bgHover: variables?.colors?.secondStepBlue,
        titleActive: variables?.colors?.darkBlue,
        titleHover: variables.colors.white,
      },
      dropdownIconHover: variables.colors.mskit4,
      opaqueDropdownHover: variables.colors.mskit4Opaque,
      iconBase: variables.colors.blue,
      iconHover: variables.colors.secondStepBlue,
      tabActive: variables.colors.msdigital2,
      tabDefault: variables.colors.darkGray,
      startBackground: variables.colors.teal,
      startBackgroundHover: variables.colors.darkTeal,
      productPreviewBackground: variables.colors.blueGray,
      previewBackground: variables.colors.teal,
    },
    checkboxes: {
      backgroundCheckedColor: variables.colors.blueGray,
      backgroundCheckedColorHover: variables.colors.darkBlue,
    },
    links: {
      primary: variables.colors.blue,
      primaryHover: variables.colors.msdigital2,
    },
    headerBase: variables.colors.darkBlue,
    headers: {
      primary: variables.colors.darkerDarkBlue,
    },
    heading: {
      level: {
        1: variables.colors.secondStepBlue,
        2: variables.colors.secondStepBlue,
        3: variables.colors.secondStepBlue,
      },
    },
    selectSiteModal: {
      overlay: variables.colors.msModalOverlay,
      buttonColor: variables.colors.white,
      backgroundColor: variables.colors.blue,
      trActive: variables.colors.darkBlue,
      modalTitle: variables.colors.darkBlue,
    },
    progressBar: {
      background: variables.colors.white,
      primary: variables.colors.lightOrange,
    },
    languageToggle: {
      backgroundColor: variables.colors.blue,
      color: variables.colors.blue,
      buttonColor: variables.colors.blue,
      hoverColor: variables.colors.darkBlue,
    },
  },
  dashboard: {
    border: {
      width: '2px',
      color: variables.colors.paleGray,
    },
  },
  individualResource: {
    activityDetails: {
      h2: {
        size: '1.5rem',
        family: variables.font.sharpSlab.bold,
      },
      a: {
        color: variables.colors.blue,
        hover: {
          color: variables.colors.darkBlue,
        },
      },
      button: {
        hover: {
          color: variables.colors.darkBlue,
        },
      },
    },
    audienceTag: {
      backgroundColor: variables.colors.msdigital6,
      color: variables.colors.darkGray,
    },
    h1: {
      fontFamily: variables.font.sharpSlab.bold,
    },
    h4: {
      fontFamily: variables.font.sharpSlab.bold,
      color: variables.colors.darkBlue,
    },
    markCompleteButton: {
      color: variables.colors.blue,
      fill: variables.colors.blue,
    },
    metaData: {
      h4: {
        backgroundColor: variables.colors.frostBlue,
      },
    },
    teachButton: {
      focusOutline: variables.colors.blue,
    },
  },
  preferencesSetup: {
    width: '222px',
    height: '185px',
    color: variables.colors.darkBlue,
  },
  firstTimeClasses: {
    titleColor: variables.colors.darkBlue,
    button: {
      backgroundColor: variables.colors.elemDigital1,
      color: variables.colors.blue,
      hoverColor: variables.colors.darkBlue,
    },
  },

  heading: {
    level: {
      1: {
        mobile: {
          height: '2.25rem',
          size: '2rem',
        },
      },
      2: {
        mobile: {
          height: '1.625rem',
          size: '1.25rem',
        },
      },
    },
  },

  // TODO: LEARN-9633, move backround images and colors to separate objects
  banners: {
    headerTextColor: variables.colors.white,
    headerTextFont: 'Sharpslab-extrabold',
    headerTextSize: '42px',
    backgroundImage: backgroundImage,
    bannerTextColor: variables.colors.white,
    landingBackgroundColor: variables.colors.msdigital2,
    landingBackgroundImage: blobImgMiddleSchool,
    sublandingBackgroundImage: subBlobImgMiddleSchool,
    alignment: 'center',
    textAlignment: 'center',
    contentTypeDescriptionBackgroundColor: variables.colors.darkBlue,
    contentTypeDescriptionBackgroundImage: contentBlobImgMiddleSchool,
    contentTypeDescriptionIconColor: variables.colors.white,
  },

  callouts: {
    headerTextColor: variables.colors.msdigital2,
    headerTextFont: 'Sharpslab-extrabold',
    headerTextSize: '28px',
    bodyTextColor: variables.colors.black,
    backgroundColor: variables.colors.white,
    iconBorderRadius: '0.688rem 0.688rem 2.813rem 0.688rem',
    boxShadow: `0rem 0rem 0.625rem ${variables.colors.gray300}`,
    categoryTileH3Color: variables.colors.white,
    svgFillColor: variables.colors.darkBlue,
  },

  anchorNavigation: {
    borderBottomStyle: 'none',
    borderBottomColor: 'none',
    borderBottomWidth: 'none',
    boxShadow: `0px 0px 10px ${variables.colors.gray300}`,
  },

  resources: {
    backgroundColorTop: variables.colors.msdigital2,
    backgroundColorBottom: variables.colors.backgroundNeutralGray,
  },
  primaryCTA: {
    training: {
      backgroundColor: variables.colors.salmon,
      titleColor: variables.colors.darkBlue,
      buttonColor: variables.colors.blue,
      buttonHoverColor: variables.colors.msdigital5,
    },
    create: {
      backgroundColor: variables.colors.msdigital6,
      titleColor: variables.colors.darkBlue,
      buttonColor: variables.colors.blue,
    },
  },
  shutterList: {
    backgroundColor: variables.colors.paleGray,
  },
  tieredInterventionUnitCard: {
    styledContainer: {
      borderColor: {
        primary: variables.colors.frostBlue,
        hover: variables.colors.blue,
      },
    },
    completionCircle: {
      borderColor: {
        primary: variables.colors.blueGray,
      },
    },
    header2: {
      color: variables.colors.darkBlue,
    },
    tagText: {
      backgroundColor: variables.colors.msdigital6,
    },
  },

  tieredInterventionHeader: {
    headerWrapper: {
      backgroundColor: variables.colors.tieredInterventionBlue,
    },
  },
  tieredInterventionCallout: {
    tieredInterventionContainer: {
      backgroundColor: variables.colors.msdigital2,
    },
  },
}
